// Texto de erro para mostrar ao usuário a partir de uma falha da API.
// A API devolve { error: "texto", errors: ["...", ...] }; versões antigas
// do backend devolviam só { campo: ["mensagem"] } — ainda aceito aqui.
export function mensagemErro(erro, padrao = "Erro inesperado.") {
  const data = erro?.response?.data;
  if (data?.error) return data.error;
  if (Array.isArray(data?.errors) && data.errors.length)
    return data.errors.join(". ");
  if (data && typeof data === "object") {
    const msgs = Object.values(data).flat().filter(Boolean);
    if (msgs.length) return msgs.join(". ");
  }
  return padrao;
}
